import { render, staticRenderFns } from "./JdsFieldGroup.vue?vue&type=template&id=044c2d95&scoped=true&"
import script from "./JdsFieldGroup.vue?vue&type=script&lang=ts&"
export * from "./JdsFieldGroup.vue?vue&type=script&lang=ts&"
import style0 from "./JdsFieldGroup.vue?vue&type=style&index=0&id=044c2d95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044c2d95",
  null
  
)

export default component.exports